const servicesGateway = {
    fetchServices: async (token: string) => {
      // const url = `/check_token/${token}`;
      try {
        // const res = await axiosClient.get(url);
        const res = [
          { id: 1, port: '480', serviceName: 'OPC',displayName:"Router",components:""},
          { id: 2, port: '501', serviceName: 'MODBUS',displayName:"Modbus Server",components:"" },
          { id: 3, port: '3306', serviceName: 'SQL',displayName:"Opc",components:""},
        ];
        return {
          status: 'success',
          res,
        };
      } catch (error) {
        return {
          status: 'error',
          error,
        };
      }
    }
}

export default servicesGateway;